// @flow

import React from 'react';
import { ColorTile } from './atoms';
import type { Props } from '../../types';
import { priceFormat } from '../../../../../../helpers';

const createTitle = (title, twoToneTitle, price) => {
  const colorPrice = priceFormat(price, {
    currency: true,
  });
  if (twoToneTitle) {
    return `${title} / ${twoToneTitle} :: ${colorPrice}`;
  }
  return `${title} :: ${colorPrice}`;
};

const ConfigColor = ({
  color,
  title,
  price,
  active,
  twoToneColor,
  twoToneTitle,
}: Props) => (
  <ColorTile
    color={color}
    title={createTitle(title, twoToneTitle, price)}
    twoToneColor={twoToneColor}
    active={active || false}
  />
);

export default ConfigColor;
